export interface Category {
  nameKey: string;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { nameKey: 'cat.shoes', name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { nameKey: 'cat.hoodies', name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { nameKey: 'cat.tshirts', name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { nameKey: 'cat.jackets', name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { nameKey: 'cat.pants', name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { nameKey: 'cat.headwear', name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { nameKey: 'cat.sets', name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { nameKey: 'cat.underwear', name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { nameKey: 'cat.jersey', name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { nameKey: 'cat.accessories', name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { nameKey: 'cat.bags', name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { nameKey: 'cat.belts', name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { nameKey: 'cat.perfumes', name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { nameKey: 'cat.other', name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';